import { useState, useEffect } from "react";
import { toastFail, toastSuccess } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../ds2/components";
import "../../index.css";
import "./DownloadDocument.css";
import { CircularProgress } from "@mui/material";
import toast from "react-hot-toast";
import { apiGetLinkRecord } from "../../services/LinkRecordService";
import {
  downloadFile,
  getAppLogoFromFilename,
  getAppLogoFromLinkRecord,
  LinkRecord,
} from "winslow-core";

export default function DownloadDocument() {
  const { collectionId, linkRecordId } = useParams();
  const [statusText, setStatusText] = useState<string>("Loading...");
  const [showProgress, setShowProgress] = useState<boolean>(true);
  const [fileName, setFileName] = useState<string | null>(null);
  const [linkRecord, setLinkRecord] = useState<LinkRecord | null>(null);

  //add icon
  const navigate = useNavigate();
  const downloadLinkRecord = async () => {
    if (linkRecord && linkRecord.links && linkRecord.links.length > 0) {
      setStatusText("File found...");

      if (linkRecord.source === "LINK") {
        toast("Opening link...", toastSuccess);
        window.open(linkRecord.links[0].url, "__new");
        return;
      }

      toast("Downloading file...", toastSuccess);
      const downloadResult = await downloadFile(
        linkRecord?.links[0].url,
        linkRecord?.links[0]?.title || "resource"
      );
      if (downloadResult) {
        toast("Downloaded", toastSuccess);
        setStatusText("Downloaded...");
        setShowProgress(false);
      } else {
        toast("Failed to download", toastFail);
        setShowProgress(false);
      }
      return;
    } else {
      setStatusText("File not found.");
      toast("Invalid - File Not Found", toastFail);
      setShowProgress(false);
    }
  };

  const loadLinkRecord = async () => {
    if (!linkRecordId) {
      toast("Invalid - File Not Found", toastFail);
      return;
    }

    const result = await apiGetLinkRecord(linkRecordId);
    if (
      result &&
      result.links &&
      result.links.length > 0 &&
      result.collectionId === collectionId
    ) {
      setFileName(result.links[0].title);

      setLinkRecord(result);
      toast("File found...", toastSuccess);
      setStatusText("");
      setShowProgress(false);
    } else {
      toast("Invalid - File Not Found", toastFail);
      setShowProgress(false);
      setStatusText("File not found.");
    }
  };

  useEffect(() => {
    loadLinkRecord();
  }, [collectionId, linkRecordId]);

  return (
    <div id="download-doc-page">
      <div className="download-doc-page-body">
        <img
          className="download-doc-winslow-icon"
          src="/logos/winslow_logo.svg"
          alt=""
          onClick={() => navigate("/")}
        />
        <div className="download-doc-page-text">
          <div className="row">
            <div className="download-doc-icon">
              {linkRecord &&
                linkRecord.links &&
                linkRecord.links.length > 0 && (
                  <>
                    <img
                      src={
                        "/icons/light-mode/app_logos/" +
                        getAppLogoFromFilename(
                          linkRecord?.links[0]?.title || ""
                        )
                      }
                      alt=""
                    />
                  </>
                )}
            </div>
            <div className="download-doc-file-name">{fileName}</div>
          </div>
        </div>
        {statusText !== "" && (
          <div className="download-doc-status-text">{statusText}</div>
        )}

        {showProgress && <CircularProgress />}
        {!showProgress && linkRecord && (
          <div className="download-doc-button">
            <Button
              variant="primary"
              onClick={downloadLinkRecord}>
              Download
            </Button>
            
            {/* <button onClick={downloadLinkRecord}>Download</button> */}
          </div>
        )}
      </div>
    </div>
  );
}
